import { render, staticRenderFns } from "./EventGrid.vue?vue&type=template&id=254ad799&scoped=true&"
import script from "./EventGrid.vue?vue&type=script&lang=js&"
export * from "./EventGrid.vue?vue&type=script&lang=js&"
import style0 from "./EventGrid.vue?vue&type=style&index=0&id=254ad799&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254ad799",
  null
  
)

export default component.exports